function toKebabCase (modalName) {
  return modalName
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
}

function prepareDialogElement (modalName, dialogData, modalScope, angularProviders) {
  const { $compile } = angularProviders

  const dialogEl = document.createElement(modalName)
  const angularEl = angular.element(dialogEl)

  // compile elements in order to angular data binding / scope work properly
  const linkFn = $compile(angularEl)

  // inject modal data inside scope
  modalScope.data = dialogData

  return {
    modalEl: linkFn(modalScope),
    modalScope
  }
}

function appendModal (modalEl) {
  const body = document.querySelector('body')
  body.append(modalEl)
}

function injectAndGetModal (params, angularProviders) {
  const { modalName, modalScope, dialogData } = params

  const { modalEl } = prepareDialogElement(modalName, dialogData, modalScope, angularProviders)
  appendModal(modalEl[0])

  return {
    modalEl: modalEl[0],
    modalScope
  }
}

function destroyModal (modal) {
  angular.element(modal).scope().$destroy()
  angular.element(modal).remove()
}

class Modal {
  constructor ($rootScope, $compile, $controller, $timeout, ModalStackService, params) {
    this.$rootScope = $rootScope
    this.$compile = $compile
    this.$controller = $controller
    this.$timeout = $timeout
    this.ModalStackService = ModalStackService

    this.controller = params.controller
    this.modalName = toKebabCase(params.modalName)

    const dialogData = params.data || {}
    const modalScope = this.$rootScope.$new()
    modalScope.noDimmer = params.noDimmer || false

    const { modalEl } = injectAndGetModal(
      {
        modalName: this.modalName,
        modalScope,
        dialogData
      },
      {
        $compile: this.$compile
      }
    )

    // save modal data to openedModalStack
    ModalStackService.registerOpenedModal({
      modalEl,
      modalScope,
      type: 'uds-modal'
    }, this.close.bind(this))

    // get modal element and scope
    this.modal = modalEl
    this.scope = modalScope

    // set methods and event listeners on close/open
    this.onEmitClose = params.onClose || function () {}
    this.onEmitOpen = params.onOpen || function () {}
    this.modalResponse = null

    modalEl.addEventListener('udsopen', (evt) => {
      this.onEmitOpen()
    })

    modalEl.addEventListener('udsclose', (evt) => {
      this.close()
    })

    this.scope.close = (data) => {
      this.modalResponse = data
      this.close()
    }

    if (typeof this.controller === 'function') {
      $controller(this.controller, { $scope: this.scope })
    }
  }

  updateModalScope (properties = {}) {
    if (!this.scope.show) {
      return
    }

    this.$timeout(() => {
      Object.keys(properties).forEach((key) => {
        this.scope.data[key] = properties[key]
      })
    })
  }

  open () {
    this.$timeout(() => {
      this.scope.show = true
      this.toggleBodyOverflow()
    }, 300)
  }

  close () {
    if (this.scope.show) {
      this.ModalStackService.closeLastOpenedModal()
      this.scope.show = false
      this.onEmitClose(this.modalResponse)
      this.toggleBodyOverflow()

      this.$timeout(() => {
        destroyModal(this.modal)
      }, 10)
    }
  }

  toggleBodyOverflow () {
    const bodyElement = document.body
    bodyElement.style.overflow = this.scope.show ? 'hidden' : 'auto'
  }
}

/* @ngInject */
class UdsModalService {
  constructor ($rootScope, $compile, $controller, $timeout, ModalStackService) {
    this.$rootScope = $rootScope
    this.$compile = $compile
    this.$controller = $controller
    this.$timeout = $timeout
    this.ModalStackService = ModalStackService
  }

  createModal (params) {
    if (!params.controller) {
      throw new TypeError('controller is required')
    }

    if (!params.modalName) {
      throw new TypeError('modalName is required')
    }

    const angularProviders = [this.$rootScope, this.$compile, this.$controller, this.$timeout, this.ModalStackService]
    return new Modal(...angularProviders, params)
  }

  static create () {
    return new UdsModalService(...arguments)
  }
}

UdsModalService.create.$inject = ['$rootScope', '$compile', '$controller', '$timeout', 'ModalStackService']

export { UdsModalService }
